import * as React from "react";

export function useSlideTitle() {
  const title = "Stocks to use-ratio vs crop price index";

  return title;
}
